import {
  ComponentMultiStyleConfig,
  HStack,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { StepItem } from "../StepItem/StepItem";

export type StepsProps = {
  steps: { label: string; description: string }[];

  activeStep: number;
} & ComponentStyleProps;

export const Steps = ({
  steps,

  activeStep,

  sx,
  ...rest
}: StepsProps) => {
  const styles = useMultiStyleConfig("StepsStyles");

  return (
    <HStack sx={{ ...styles.container, ...sx }} {...rest}>
      {steps.map((s, idx) => (
        <StepItem
          key={idx}
          label={s.label}
          description={s.description}
          active={idx === activeStep}
          sx={styles.stepItem}
        />
      ))}
    </HStack>
  );
};

export const StepsStyles: ComponentMultiStyleConfig = {
  parts: ["container", "stepItem"],
  baseStyle: {
    container: {},
    stepItem: {
      flex: 1,

      minW: "100px",
    },
  },
};
